export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10051.72e4496c.jpg";